exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dashboard-wrapper{background:#e6e6e6;display:flex;flex-wrap:wrap;flex-direction:row;min-height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Dashboard/Dashboard.scss
// module id = 845
// module chunks = 0